<template>
  <div>
    <Head title="Preise" />
    <section class="py-3 lg:px-10 text-sm md:text-base">
      <h2 class="mb-2 md:mb-7">Preise</h2>
      <p class="text-sm md:text-base">Die Wohnung wird erst ab 4 Nächten und 4 Personen vermietet.</p>
      <p class="text-sm md:text-base">140,00 € pro Nacht inkl. 4 Personen inkl. Bettwäsche, Handtücher, Nebenkosten und Endreinigung</p>
      <p class="text-sm md:text-base">jede weitere Person ab 17 Jahre 35,00 €</p>
      <p class="text-sm md:text-base">Kinderbett einmalig 10,00 €</p>
      <p class="text-sm md:text-base">weitere Aufbettung nach Absprache möglich</p>
      <p class="text-sm md:text-base">Endreinigung inkl. siehe <a :href="route('frontend.legal.terms')" class="hover:underline">AGB</a></p>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script>
